<template>
  <div>
    <b-form>
      <div class="pull-right form-group">
        <b-button @click="section = 'add_unit'" variant="success">Add Unit &nbsp;<i class="fa fa-plus"></i></b-button>
      </div>
    </b-form>
    <b-table striped
    :items="(isFetched ? unitTable.items : dataBeforeLoad)"
    :fields="unitTable.fields"
    :class="isLoading ? 'show__blur' : ''">
      <template #cell(number)="data">
        {{data.value}}
        <b-badge v-if="checkRejectedUnit(data.item.id)" variant="danger">Rejected</b-badge>
        </template>
      <template #cell(type)="data">{{data.value}}</template>
    </b-table>
    <div
      class="show__loading"
      v-if="isLoading"
      :style="`height: ${dataBeforeLoad.length*75+70}px;`">
      <center>
      <i
        class="fa fa-spinner fa-pulse fa-4x fa-modify"
        alt="Loading"
        :style="`margin-bottom: ${(dataBeforeLoad.length*75+50)/2}px;`"></i>
      </center>
    </div>
    <!-- <b-alert v-if="unitTable.items.length === 0" show>There's no units available.</b-alert> -->
    <b-alert show v-if="isFetched && unitTable.items.length === 0" class="alert">There's no data available.</b-alert>
  </div>
</template>
<script>
import { isUndefined, cloneDeep, get, isEmpty } from 'lodash';

export default {
  name: 'order_unit_list',
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[4] || '',
      unitTable: {
        fields: ['number', 'type'],
        items: [],
      },
      dataBeforeLoad: [],
    };
  },
  created() {
    const { orderId, shipmentId } = this.$route.params;
    const breadcrumb = [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
    ];

    if (!isUndefined(shipmentId)) {
      breadcrumb.push({ to: 'shipments', name: 'Shipments' });
      breadcrumb.push({ to: `${shipmentId}/orders`, name: 'Detail' });
      breadcrumb.push({ to: orderId, name: 'Order Detail' });
    } else {
      breadcrumb.push({ to: 'orders', name: 'Orders' });
      breadcrumb.push({ to: orderId, name: 'Detail' });
    }

    this.$store.commit('shipment_md/orders/SET_DETAIL_ID', orderId);
    this.$store.commit('SET_BREADCRUMB_ITEMS', breadcrumb);
    this.$store.dispatch('shipment_md/orders/LOAD_DETAIL_DATA');
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['shipment_md/orders/get_detail_data'];
    },
    orderId() {
      return this.$route.params.orderId;
    },
    orderUnit() {
      return this.$store.getters['shipment_md/orders/dataOrderUnit'];
    },
    isLoading() {
      return this.orderUnit === 'LOADING';
    },
    isFetched() {
      return this.orderUnit === 'LOADED';
    },
  },
  methods: {
    loadData() {
      this.dataBeforeLoad = cloneDeep(this.unitTable.items);
    },
    checkRejectedUnit(id) {
      const status = get(this.detailedInfo, `metadata.rejected_units.${id}`);
      return !isEmpty(status);
    },
  },
  watch: {
    detailedInfo(data) {
      const { units } = data;
      this.unitTable.items.splice(0);
      units.forEach((v) => {
        this.unitTable.items.push(v);
      });
    },
    section(newSection) {
      this.$router.push(`/shipment_md/orders/${this.orderId}/${newSection}`);
    },
  },
};
</script>
<style lang="sass">
.show__loading
  height: 800px
  width: 96.5%
  position: absolute
  opacity: 0.3
  background-color: #9E9E9E
  bottom: -30px

.alert
  bottom: 15px
  width: 100%
  text-align: center

.show__blur
  -webkit-filter: blur(1px)
  -moz-filter: blur(1px)
  -ms-filter: blur(1px)
  -o-filter: blur(1px)
  filter: blur(1px)
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/orders/detail/Units.vue